import { AuthLayoutProps } from "@/types/layouts"
import React from "react"
import logoIcon from "@/assets/Logo.svg"
import styles from "./AuthLayout.module.scss"

const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => {
  return (
    <main className={styles.authLayout}>
      <header className={styles.authLayoutHeader}>
        <img
          src={logoIcon}
          alt="KEYP"
          className={styles.authLayoutHeaderLogo}
        />
        <span className={styles.authLayoutHeaderText}>KEYP</span>
      </header>
      <div className={styles.authLayoutContent}>{children}</div>
    </main>
  )
}

export default AuthLayout
